// extracted by mini-css-extract-plugin
export default {"BackButton":"styles_BackButton__L7Ecg","BackButton__Float":"styles_BackButton__Float__RGYY5","BackButton__Large":"styles_BackButton__Large__T83pv"};